import { render, staticRenderFns } from "./NavigationDrawerManutencaoCriar.vue?vue&type=template&id=22964f16&scoped=true&"
import script from "./NavigationDrawerManutencaoCriar.vue?vue&type=script&lang=ts&"
export * from "./NavigationDrawerManutencaoCriar.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationDrawerManutencaoCriar.vue?vue&type=style&index=0&id=22964f16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22964f16",
  null
  
)

export default component.exports